import { SectionHeading } from "@themes/pollinator/ui/SectionHeading";
import { OrganizationProfileFormContainer } from "../../forms/OrganizationProfileForm";
import { LogosUploadContainer } from "../LogosUpload";
import { LogosTableContainer } from "../LogosTable";

export type Props = {
  /** Organization ID */
  organizationId: number;
  /** Optional callback on save success */
  onSaveSuccess?: () => void;
};

/**
 * Profile tab content for organization admin page.
 * Displays the organization profile form for editing org info and social links,
 * logo upload, and logo management table.
 */
export function OrgProfileTab({ organizationId, onSaveSuccess }: Props) {
  return (
    <div
      className="w-full flex flex-col gap-8 pb-8 max-w-3xl"
      data-testid="org-profile-tab"
    >
      <SectionHeading
        title="Organization Profile"
        description="Update your organization information and social media links."
      >
        <OrganizationProfileFormContainer
          organizationId={organizationId}
          onSaveSuccess={onSaveSuccess}
        />
      </SectionHeading>

      <SectionHeading
        title="Upload Logo"
        description="Upload a logo for your organization."
      >
        <LogosUploadContainer organizationId={organizationId} />
      </SectionHeading>

      <SectionHeading
        title="Organization Logos"
        description="Manage your organization's logos. Set a main logo or remove unused ones."
      >
        <LogosTableContainer organizationId={organizationId} />
      </SectionHeading>
    </div>
  );
}

export default OrgProfileTab;
